import { ERROR_KEYS, WALLETS_STORE_MUTATIONS } from './types';
import { PROCESSING_DISPATCH_API } from '~/app/modules/processing';
import { MOBILE_OPERATOR_CODES_DEFAULT } from '~/app/modules/processing/utils/const';
import { CLASSIFICATION } from '~/app/shared/utils/classification';

const state = () => ({
  errors: {
    updateWalletInfo: [],
  },
  mobileOperatorCodes: [],
  walletsList: [],
  wallet: {
    type: '',
    number: '',
  },
});

const mutations = {
  setErrors({ errors }, { key, value }) {
    if (key in errors) {
      errors[key] = value;
    }
  },

  clearErrors({ errors }) {
    errors = {
      updateWalletInfo: [],
    };
  },

  setWallets(state, wallets) {
    state.walletsList = wallets;
  },

  setMobileOperatorCodes(state, codes) {
    state.mobileOperatorCodes = codes;
  },

  setWalletData({ wallet }, { key, value }) {
    if (key in wallet) {
      wallet[key] = value;
    }
  },
};

const getters = {
  isPhoneHaveValidOperatorCode(store) {
    return function(phone) {
      return store.mobileOperatorCodes.includes(phone.slice(0, 2));
    };
  },

  isPhoneNumbersEqual(store, getters, rootState, rootGetters) {
    const clientInfo = rootGetters['client/active'].info;

    return clientInfo.mobilePhone.number === clientInfo.wallet.number;
  },
};

const actions = {
  async getWallets({ commit }) {
    const wallets = await this.$classification.get(CLASSIFICATION.WALLETS);

    if (!wallets || !wallets.length) {
      this.$sentry.captureException(new Error('Failed to get wallets from classification'));
      return;
    }

    commit(WALLETS_STORE_MUTATIONS.SET_WALLETS, wallets);
  },

  async getMobileOperatorCodes({ commit }) {
    const mobileOperators = await this.$classification.get(CLASSIFICATION.MOBILE_OPERATORS, false);

    if (!mobileOperators) {
      this.$sentry.captureException(new Error('Failed to get mobileOperators from classification'));
      commit(WALLETS_STORE_MUTATIONS.SET_MOBILE_OPERATOR_CODES, MOBILE_OPERATOR_CODES_DEFAULT);
      return;
    }

    commit(WALLETS_STORE_MUTATIONS.SET_MOBILE_OPERATOR_CODES, Object.keys(mobileOperators));
  },

  async updateWalletInfo({ state, commit }) {
    commit(WALLETS_STORE_MUTATIONS.CLEAR_ERRORS);

    const { success, errors } = await this.$api.dispatch(PROCESSING_DISPATCH_API.EWALLET_CHANGE, {
      ...state.wallet,
    });

    if (!success) {
      commit(WALLETS_STORE_MUTATIONS.SET_ERRORS, {
        key: ERROR_KEYS.UPDATE_WALLET_INFO,
        value: errors,
      });

      return false;
    }

    this.$auth.fetchUser();

    return true;
  },
};

export const walletsStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
